import React from 'react';
import { Link } from 'react-router-dom'; // 1. Import Link
import './Services.css';

// Import the specific icons we need
import { FaRupeeSign, FaUniversity, FaNewspaper, FaChartBar, FaFileAlt, FaFileSignature, FaCalendarCheck, FaSyncAlt, FaChartLine } from 'react-icons/fa';

const servicesData = [
  { icon: <FaRupeeSign />, name: 'Prices & Indices' },
  { icon: <FaUniversity />, name: 'Futures' },
  { icon: <FaNewspaper />, name: 'News & Insights' },
  { icon: <FaChartBar />, name: 'Data & Statistics' },
  { icon: <FaFileAlt />, name: 'Reports' },
  { icon: <FaFileSignature />, name: 'Notifications' },
  { icon: <FaCalendarCheck />, name: 'Events' },
  { icon: <FaSyncAlt />, name: 'Consulting' },
  { icon: <FaChartLine />, name: 'Forecasting' }
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="section-header">
        <h2>Our Services</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        Through our diverse services, we help you make confident decisions in the ever-changing crop market.
      </p>

      <div className="services-grid">
        {servicesData.map((service, index) => {
          // 2. Conditionally wrap the item in a Link
          if (service.name === 'Prices & Indices') {
            return (
              <Link to="/prices" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">
                    {service.icon}
                  </div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          }
          else if (service.name === 'News & Insights') {
            return (
              <Link to="/insights" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
          else if (service.name === 'Data & Statistics') {
          return (
            <Link to="/data-statistics" key={index} className="service-item-link">
              <div className="service-item">
                <div className="icon-circle">{service.icon}</div>
                <p className="service-name">{service.name}</p>
              </div>
            </Link>
          );
        }
        else if (service.name === 'Reports') {
            return (
              <Link to="/reports" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
          else if (service.name === 'Notifications') {
            return (
              <Link to="/tenders" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
           else if (service.name === 'Consulting') {
            return (
              <Link to="/consulting" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
          else if (service.name === 'Forecasting') {
            return (
              <Link to="/forecasting" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
          else if (service.name === 'Events') {
            return (
              <Link to="/events" key={index} className="service-item-link">
                <div className="service-item">
                  <div className="icon-circle">{service.icon}</div>
                  <p className="service-name">{service.name}</p>
                </div>
              </Link>
            );
          } 
          // Render a normal div for all other items
          else
          return (
            <div key={index} className="service-item">
              <div className="icon-circle">
                {service.icon}
              </div>
              <p className="service-name">{service.name}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Services;